import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Button from "../../shared/Button"
import { LineChart, PieChart } from "@mui/x-charts"
import InputSelect from "../../shared/input/new/InputSelect"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { getLoadRegistrationReport } from "../../../features/reports/reportSlice"
import React, {  } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1200px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .content{
            margin-block: 20px;
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            .top-container{
                margin-bottom: 30px;
            }
            .title-list{
                display: flex;
                align-items: center;
                justify-content: space-between;
                text-align: center;
                width: 100%;
                gap: 20px;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                margin-bottom: 20px;
                padding-bottom: 10px;
                border-bottom: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                .title{
                    width: 30%;
                }
                .title:first-of-type{
                    width: 10%;
                }
            }
            .main-side{
                text-align: center;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .info{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 20px;
                    .text:first-of-type{
                        width: 10%;
                    }
                    .text{
                        text-align: center;
                        width: 30%;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                }
            }
            .total-container{
                display: flex;
                align-items: center;
                justify-content: space-between;
                text-align: center;
                gap: 20px;
                width: 100%;
                margin-top: 20px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                border-top: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                padding-top: 10px;
                .total{
                    width: 10%;
                    font-size: var(--font-size-md);
                }
                .calc{
                    width: 30%;
                }
            }
            .charts{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 30px;
                flex-direction: column;
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            padding-block: 30px;
        }
    }
`

const titles = ["Ay", "Talep Edilen Araç Sayısı", "Karşılanan Arac Sayısı / Oranı", "Karşılanmayan Araç Sayısı / Oranı"]

const yearData = [
    {
        id:1,
        text:"2024"
    }
]

const YukKaydiRaporModal = () => {

    const dispatch = useDispatch()

    const location = useLocation()

    const {yukKaydiRaporList } = useSelector(state => state.report)
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [talepTotal, setTalepTotal] = useState(0)
    const [karsilananTotal, setKarsilananTotal] = useState(0)
    const [karsilananTotalPerch, setKarsilananTotalPerch] = useState(0)
    const [karsilanmayanTotal, setKarsilanmayanTotal] = useState(0)
    const [karsilanmayanTotalPerch, setKarsilanmayanTotalPerch] = useState(0)

    const [formattedList, setFormattedList] = useState([])

    useEffect(() => {
        setFormattedList(yukKaydiRaporList?.map((item,index) => {
            const newIndex = index+1
            return {
                ...item,
                id: newIndex,
                Talep: item?.requestedVehicleCount,
                Karşılanan: item?.suppliedVehicleCount,
                Karşılanmayan: item?.notSuppliedVehicleCount
            }
        }))
    }, [yukKaydiRaporList])

    const [year, setYear] = useState({
        id:1,
        text:"2024"
    })
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const companyId = JSON.parse(storage.getItem("companyId"))    

    useEffect(() => {
        dispatch(getLoadRegistrationReport({companyId: companyId, yearSelection: parseInt(year?.text)}))
    }, [year?.text, companyId])

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(() => {
        const totalTalep = yukKaydiRaporList?.reduce((accumulator, currentItem) => accumulator + currentItem.requestedVehicleCount, 0);
        const totalKarsilanan = yukKaydiRaporList?.reduce((accumulator, currentItem) => accumulator + currentItem.suppliedVehicleCount, 0);
        const totalKarsilanmayan = yukKaydiRaporList?.reduce((accumulator, currentItem) => accumulator + currentItem.notSuppliedVehicleCount, 0);

        if(totalTalep && totalKarsilanan && totalKarsilanmayan){
            const karsilananPercentage = (totalKarsilanan / totalTalep) * 100;
            const karsilanmayanPercentage = (totalKarsilanmayan / totalTalep) * 100;
            setTalepTotal(totalTalep)

            setKarsilananTotal(totalKarsilanan)
            setKarsilananTotalPerch(karsilananPercentage?.toFixed(0))

            setKarsilanmayanTotal(totalKarsilanmayan)
            setKarsilanmayanTotalPerch(karsilanmayanPercentage?.toFixed(0))
        }
    }, [yukKaydiRaporList])

    const seriesData = [
        {
            data:  [
                { id: 1, value: karsilananTotalPerch, label: 'Karşılanan Arac Oranı', color:"#E85446" },
                { id: 2, value: karsilanmayanTotalPerch, label: 'Karşılanmayan Araç Oranı', color:"#000" },
            ]
        },
    ]
    
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle padding="15px 30px" title={"Yük Kaydı Raporu"}/>
            <div className="content">
                <div className="top-container">
                    <InputSelect data={year?.text} setData={setYear} initialOptions={yearData} name={"year"} labelText={"Yıl Seçimi"} inputWidth={"200px"} />
                </div>
                
                <div className="title-list">
                    {titles.map((item) => (
                        <div className="title">{item}</div>
                    ))}
                </div>
                <div className="main-side">
                    {yukKaydiRaporList.map((item) => {
                        const karsilananPercentage = (item?.suppliedVehicleCount / item?.requestedVehicleCount) * 100;
                        const karsilanmayanPercentage = (item?.notSuppliedVehicleCount / item?.requestedVehicleCount) * 100;
                        return(
                        <div className="info">
                            <div className="text">{item?.month}</div>
                            <div className="text">{item?.requestedVehicleCount}</div>
                            <div className="text">
                                {item?.suppliedVehicleCount} ({!isNaN(karsilananPercentage?.toFixed(0))}%)
                            </div>
                            <div className="text">
                                {item?.notSuppliedVehicleCount} ({!isNaN(karsilanmayanPercentage?.toFixed(0))}%)
                            </div>
                        </div>
                    )})}
                </div>
                <div className="total-container">
                    <div className="total">Toplam</div>
                    <div className="calc">{talepTotal}</div>
                    <div className="calc">{karsilananTotal} ({karsilananTotalPerch}%)</div>
                    <div className="calc">{karsilanmayanTotal} ({karsilanmayanTotalPerch}%)</div>
                </div>
                <div className="charts">
                    <PieChart
                        series={seriesData}
                        width={600}
                        height={200}
                    />
                    <ResponsiveContainer width="75%" height="60%">
                        <BarChart
                        width={400}
                        height={200}
                        data={formattedList}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="id" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="Talep" stackId="a" fill="#E85446" />
                            <Bar dataKey="Karşılanan" stackId="a" fill="#5CB34F" />
                            <Bar dataKey="Karşılanmayan" fill="#000" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                <div className='button-grp'>
                    <Button color={"#F4F4F4"} background={"#E85446"} width="310px" radius={"10px"} text={"Geri Dön"} handleClick={()=> dispatch(showModal(null))}/>
                </div>
            </div>
        </div>
    </ModalContainer>
  )
}

export default YukKaydiRaporModal